import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { KNOWN_FEATURE_FLAGS } from '@core/models/feature-flags/known-feature-flags';
import { canOpenOptimizations } from '@core/models/optimization-job-actions';
import { selectAuthChecked, selectUser } from '@core/store/auth/auth.selectors';
import { selectFeatureFlagsState } from '@core/store/feature-flags/feature-flags.selectors';

export const optimizationsGuard: CanActivateFn = (): MaybeAsync<GuardResult> => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectAuthChecked),
    store.select(selectFeatureFlagsState)
  ]).pipe(
    // A failed load never sets `loaded`; it is read as every flag off, which still admits super users.
    filter(([authChecked, flags]) => authChecked && (flags.loaded || flags.error !== null)),
    take(1),
    map(([, flags]) => {
      const role = store.selectSignal(selectUser)()?.role;
      const flagActive = flags.activeFeatures.includes(
        KNOWN_FEATURE_FLAGS.SHOW_OPTIMIZATIONS_MENU
      );
      return canOpenOptimizations(role, flagActive) || router.createUrlTree(['/']);
    })
  );
};
